<template>
  <div class="toast-wrapper">
    <div class="base-toast" :style="{width: width + 'px'}">
      <div class="icon">
        <img src="../../../public/custom/images/Success.svg" alt="success icon">
      </div>
      <div class="message">
        <span class="text">{{ toastMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseToast',
  props: {
      toastMessage: String,
      isShown: {
          type: Boolean,
          default: false
      },
      width: Number
  }
}
</script>

<style lang="scss" scoped>
  .base-toast {
      box-shadow: 0px 0px 8px -3px rgba(34, 60, 80, 0.2);
      width: 310px;
      height: 50px;
      position: fixed;
      top: 2%;
      right: 3%;
      display: flex;
      align-items: center;
      border: 1px solid #03B325;
      border-radius: 10px;
      background-color: #ffffff;
      z-index: 5;
  }

  .icon {
      height: 50%;
      margin-left: 10px;
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
  }

  .message {
      width: 85%;
      height: 50%;
      display: flex;
      align-items: center;

      .text {
          font-family: 'Open Sans', sans-serif;
          font-size: 15px;
          font-weight: 400;
          color: #000000;
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
      }
  }
</style>
